import React, { memo } from 'react';
import { bool, string, shape, number } from 'prop-types';
import StyledLabel from '../styled-label';
import Tooltip from '../tooltip';
import MediaAction from '../media/media-action';
import { trackEvent } from '../../lib/tracking';
import { getVerifiedTooltipContent } from './components/verified-tooltip-content';
import { getVerifiedBadgeContent } from './components/verified-badge-content';

const namespace = 'ui-pdp-verified-vehicles-tag';

const VerifiedVehiclesTag = ({ tag_action: { label, andes_tooltip }, additional_description, campaign_link }) => {
  const verifiedBadge = getVerifiedBadgeContent(label, !!andes_tooltip);
  return (
    <>
      <div key={namespace} className={`${namespace}__verified-badge-container`}>
        {!andes_tooltip ? (
          verifiedBadge
        ) : (
          <Tooltip
            className={`${namespace}__verified-badge-tooltip`}
            content={getVerifiedTooltipContent(andes_tooltip.body)}
            closable={andes_tooltip.closeable}
            mask
            maskClosable={false}
            offsetX={-26}
            offsetY={1}
            side="left"
            trigger="click"
          >
            {verifiedBadge}
          </Tooltip>
        )}
      </div>

      {additional_description && (
        <StyledLabel className={`${namespace}__additional-description`} {...additional_description} />
      )}

      {campaign_link && (
        <div className={`${namespace}__campaign-link`}>
          <StyledLabel {...campaign_link.label} as="span" />
          {campaign_link.target && (
            <MediaAction
              className={`${namespace}__campaign-link-action`}
              label={campaign_link.label.values.blue_text}
              target={campaign_link.target}
              htmlTarget={campaign_link.html_target}
              accessibilityText={campaign_link.accessibility_text}
              onClick={() => {
                trackEvent(campaign_link.track);
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

VerifiedVehiclesTag.propTypes = {
  tag_action: shape({
    label: shape({
      text: string.isRequired,
      color: string,
      bg_color: string,
      font_family: string,
      classname: string,
    }).isRequired,
    andes_tooltip: shape({
      state: string.isRequired,
      closeable: bool,
      body: shape({
        text: string.isRequired,
        color: string,
        font_family: string,
      }).isRequired,
    }),
  }),
  additional_description: shape({
    text: string,
    color: string,
    bg_color: string,
    font_size: string,
    font_family: string,
  }),
  additional_info: shape({
    text: string,
    color: string,
    bg_color: string,
    font_size: string,
    font_family: string,
  }),
  campaign_link: shape({
    target: string,
    html_target: string,
    accessibility_text: string,
    timeout: number,
    duration: number,
    label: shape({
      text: string.isRequired,
      color: string,
      font_size: string,
      font_family: string,
      values: shape({
        blue_text: shape({
          text: string,
          color: string,
          font_size: string,
          font_family: string,
        }),
      }),
    }),
    track: shape({
      melidata_event: shape({
        path: string,
        event_data: shape({
          item_id: string,
          category_id: string,
        }),
      }),
    }),
    action_type: string,
  }),
};

export default memo(VerifiedVehiclesTag);
